import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { i18n } from '../../i18n/translate.js';

var ExpandableList = function ExpandableList(_ref) {
  var _ref$minVisibleItems = _ref.minVisibleItems,
      minVisibleItems = _ref$minVisibleItems === void 0 ? 3 : _ref$minVisibleItems,
      data = _ref.data,
      className = _ref.className,
      onExpand = _ref.onExpand;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var listItemsNr = data.length;

  var onClickHandler = function onClickHandler(event) {
    setShowMore(!showMore);

    if (onExpand) {
      onExpand(showMore, event);
    }
  };

  var showButtonText = function showButtonText(listItemsNr) {
    if (!showMore) {
      return /*#__PURE__*/React.createElement("span", null, "+ ", listItemsNr - minVisibleItems, " ", i18n.t('More'));
    }

    return /*#__PURE__*/React.createElement("span", null, i18n.t('Less'));
  };

  var list = data.map(function (_ref2, index) {
    var label = _ref2.label;

    if (index < minVisibleItems) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, label);
    }

    return showMore ? /*#__PURE__*/React.createElement("li", {
      key: index
    }, label) : null;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("ul", null, list), listItemsNr > minVisibleItems ? /*#__PURE__*/React.createElement("button", {
    className: "toggle-button",
    onClick: onClickHandler
  }, showButtonText(listItemsNr)) : null);
};

ExpandableList.displayName = "ExpandableList";
export { ExpandableList };